import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Login from './views/Login.vue'
import Swipe from './views/Swipe.vue'

let router = [
    {
      path: '/login',
      component: Login
    },
    { path: '/*',
      component: NotFound
    },
    {
      path: '/swipe/card',
      component: Swipe
    }
];
export default router
